import { Form } from '../core'

$.fn.Quiz = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.melia-quiz', {
      ajax_redirect: false,
      steps: {
        use_steps: true,
        submit_steps: false,
      },
      onInit: function(quiz) {
        quiz.find('.field__next').addClass('disabled')
        quiz.find('input[type="radio"]').on('change', function() {
          var next_step = $(this).closest('.form-steps__step').attr('data-name').charAt(1)
          next_step = parseInt(next_step) + 1
          quiz.find('.form-steps__step[data-name="l' + next_step + '"] .field-container').attr('aria-expanded', 'false')
          if ($(this).is(':checked')) {
            quiz.find('.form-steps__step[aria-expanded="true"]').attr('data-current-path', $(this).val())
            quiz.find('.field-container--'+$(this).val()).attr('aria-expanded', 'true')
            if ($(this).val().substring(0, 2) == 'P_') {
              quiz.find('.field__results').removeClass('hidden')
              quiz.find('.field__next').addClass('disabled')
              quiz.find('.field__next').addClass('hidden')
            } else {
              quiz.find('.field__next').removeClass('disabled')
              quiz.find('.field__next').removeClass('hidden')
              quiz.find('.field__results').addClass('hidden')
            }
          }
        })
        quiz.find('.start-over').on('click', function() {
          quiz.find('input[type="radio"]').prop('checked', false).prop("disabled", false)
          quiz.find('.field__results, .field__next, .field__previous').prop("disabled", false)
          quiz.steps.go_to_step(1)
          quiz.find('.quiz-results-list').remove();
        })
        quiz.find('.field__results').on('click', function() {
          quiz.submit();
        })
      },
      onSubmit: function(quiz) {
        var current_step = quiz.steps.get_current_step().name.charAt(1)
        var current_choice = quiz.find('.form-steps__step[data-name="l'+current_step+'"]').attr('data-current-path')
        if (current_choice.substring(0, 2) == 'P_') {
          $.ajax({
            url: '/wp/wp-admin/admin-ajax.php?action=productSuggestions&products='+current_choice,
            type: 'GET',
            processData: false,
            contentType: false,
            cache: false,
            success:function(data){
              $(data).appendTo(quiz.find('.form-steps__step[data-name="results"] .row'));
              quiz.steps.go_to_step(quiz.find('.form-steps__step[data-name="results"]').index()+1);
            }
          })
        }
        quiz.find('.start-over').prop("disabled", false);
      },
      onSuccess: function() {
      },
      onError: function() {
      },
      onStep: function(quiz) {
        quiz.find('.field__next').addClass('disabled')
      },
      onFeedback: function(response, parcours) {
      }
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.QuizPage = function() {
  let self = this
  self.find('.quiz-page__start').on('click', function() {
    self.find('.quiz-page__content').fadeOut(300, function() {
      self.find('.quiz-page__wrapper').fadeIn()
    });
  })

  self.find('.quiz-page__close').on('click', function() {
    self.find('.quiz-page__wrapper').fadeOut(300, function() {
      self.find('.start-over').trigger("click");
      self.find('.quiz-page__content').fadeIn()
    });
  })

  return function() {
    return self
  }()
}
